'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$23() {
  this.bf1 = null;
  this.beZ = null;
  this.bf0 = false;
  this.beX = null;
  this.beY = false;
  this.bf2 = false;
  this.bf3 = false;
  this.bf1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$23 as $c_Lpresto_PrestoRouter$$anon$23 };
$p = $c_Lpresto_PrestoRouter$$anon$23.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$23;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$23() {
}
export { $h_Lpresto_PrestoRouter$$anon$23 as $h_Lpresto_PrestoRouter$$anon$23 };
$h_Lpresto_PrestoRouter$$anon$23.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bf1;
});
$p.t = (function() {
  if ((!this.bf0)) {
    this.beZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bf0 = true;
  }
  return this.beZ;
});
$p.ad = (function() {
  if ((!this.beY)) {
    this.beX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.beY = true;
  }
  return this.beX;
});
$p.v = (function() {
  if ((!this.bf3)) {
    this.bf2 = false;
    this.bf3 = true;
  }
  return this.bf2;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$23 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$23, "presto.PrestoRouter$$anon$23", ({
  NX: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$23 as $d_Lpresto_PrestoRouter$$anon$23 };
//# sourceMappingURL=presto.-Presto-Router$$anon$23.js.map
